module.exports = __webpack_public_path__ + "img/2006.1f940404.png";